import React from 'react';
import AdminLayout from '../../../../components/Layout/AdminLayout';
import AddDeliveryVehicle from './AddDeliveryVehicle';
import { restrictUrls } from '../../../../helpers/adminPrivileges';
import messages from '../../../../locale/messages';

function action({ store, intl }) {
  const title = intl.formatMessage(messages.addDeliveryVehicle);

  // From Redux Store
  let isAdminAuthenticated = store.getState().runtime.isAdminAuthenticated;
  let adminPrivileges = store.getState().account.privileges && store.getState().account.privileges.privileges;
  let privileges = store.getState().commonSettings && store.getState().commonSettings.privileges;

  if (!isAdminAuthenticated) {
    return { redirect: '/siteadmin/login' };
  }

  // Admin restriction
  if (!restrictUrls('/siteadmin/vehicle-type/add', adminPrivileges, privileges)) {
    return { redirect: '/siteadmin' };
  }

  return {
    title,
    component: (
      <AdminLayout>
        <AddDeliveryVehicle title={title} />
      </AdminLayout>
    ),
  };
}

export default action;
